import { render, staticRenderFns } from "./StatisticsChart.vue?vue&type=template&id=196a6700&scoped=true"
import script from "./StatisticsChart.vue?vue&type=script&lang=js"
export * from "./StatisticsChart.vue?vue&type=script&lang=js"
import style0 from "./StatisticsChart.vue?vue&type=style&index=0&id=196a6700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a6700",
  null
  
)

export default component.exports